import { apiSlice } from "../../app/api/apiSlice";
import { getMimeTypeFromFilename, GENERIC_FALLBACK_CONTENT_TYPE } from "../../utils/document-validation";

export const fetchEnhancedConditionsUploadAttachmentUrlAndAssignEfolder =
	apiSlice.injectEndpoints({
		endpoints: (builder) => ({
			enhancedConditionsUploadAttachmentUrlAndAssignEfolder: builder.mutation({
				query: (credentials) => ({
					url: `api/v1/loan/get_enhanced_conditions_documents_upload_url_and_assign_to_efolder/${credentials.loanGuid}/`,
					method: "POST",
					body: (() => {
						const userEmail = String(
							credentials?.user_email ??
								credentials?.body?.user_email ??
								credentials?.formData?.get?.("user_email") ??
								""
						).trim();

						const defaultBody = {
							file: {
								contentType:
									credentials.contentType ||
									getMimeTypeFromFilename(credentials.fileName) ||
									GENERIC_FALLBACK_CONTENT_TYPE,
								name: credentials.fileName,
								size: credentials.size ?? 10000,
							},
							title: credentials.title,
							assignTo: {
								entityId: credentials.efolderId,
								entityType: "Document",
							},
						};

						if (
							typeof FormData !== "undefined" &&
							credentials?.body instanceof FormData
						) {
							if (userEmail && !credentials.body.has("user_email")) {
								credentials.body.append("user_email", userEmail);
							}

							return credentials.body;
						}

						if (
							typeof FormData !== "undefined" &&
							credentials?.formData instanceof FormData
						) {
							if (userEmail && !credentials.formData.has("user_email")) {
								credentials.formData.append("user_email", userEmail);
							}

							return credentials.formData;
						}

						return {
							...(credentials.body ?? credentials.formData ?? defaultBody),
							...(userEmail ? { user_email: userEmail } : {}),
						};
					})(),
				}),
			}),
		}),
	});

export const {
	useEnhancedConditionsUploadAttachmentUrlAndAssignEfolderMutation,
} = fetchEnhancedConditionsUploadAttachmentUrlAndAssignEfolder;
